/*! @azure/msal-common v14.10.0 2024-05-07 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.10.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
